<template>
  <div>
    <div style="margin:20px 0;">
      <el-button size="medium" @click="addPrice">新增</el-button>
      <el-button size="medium" @click="exportPrice" v-if="false">导入</el-button>
      <el-button size="medium" @click="deleteAll" :disabled="this.tableData.length===0">一键清空</el-button>
    </div>
    <div style="background:white;border-radius:3px">
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column prop="index" label="序号" width="80" type="index"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="特殊加点产品名称"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <!-- <el-table-column prop="PRODUCT_CODE" label="单位"></el-table-column> -->
        <el-table-column prop="POINT" label="加点"></el-table-column>
        <el-table-column prop="action" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editName(scope.row)">修改加点</el-button>
            <el-button type="text" size="small" @click="deleteName(scope.row)">删除</el-button>
            <!-- <el-button type="text" size="small" @click="exportTable(scope.row)">导出</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增特殊产品加点" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item label="产品名称：" :label-width="formLableWidth">
          <el-autocomplete class="inline-input" v-model="addForm.productName" :fetch-suggestions="querySearch"
            placeholder="请输入产品名称" :trigger-on-focus="false" @select="handleSelect" clearable></el-autocomplete>
        </el-form-item>
        <el-form-item label="加点级别：" :label-width="formLableWidth">
          <el-input v-model="addForm.POINT" placeholder="请输入加点级别"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitAddPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :visible.sync="editDialog" @close="editDialog = false" title="修改特殊产品加点" width="400px" center>
      <el-form ref="editForm" v-model="editForm" :inline="true">
        <el-form-item label="加点级别：" :label-width="formLableWidth">
          <el-input v-model="editForm.POINT" placeholder="请输入加点级别"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="editDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitEditPrice">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="exportDialog" title="导入" @close="exportDialog = false" width="400px" center>
      <el-form ref="exportForm" v-model="exportForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove"
          :on-success="handleSuccess" :name="this.exportForm.excel" :multiple="false" :limit="1" accept=".xls,.xlsx"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadSKU" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入SKU模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="closePrice">取消</el-button>
        <el-button class="operate-btn" @click="submitAddSKU">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      value: '',
      tableData: [],
      fileList: [],
      supplierList: [],
      formLableWidth: '100px',
      addForm: {
        product: '',
        POINT: '',
        PRODUCT_CODE: '',
      },
      product: [],
      addDialog: false,
      exportDialog: false,
      // 修改模态框
      editDialog: false,
      file_name: '',
      exportForm: {
        excel: 'tmp',
      },
      editForm: {},
      GYS_ID: Number(sessionStorage.getItem('tcId')),
      SCHEME_ID: this.$route.params.SCHEME_ID,

    };
  },
  created() {
    this.getProduct();
    // this.queryProductCatalog()
  },
  methods: {
    //  进行搜索
    querySearch(queryString, callback) {
      this.$_getSearchRushOrderList(queryString).then((res) => {
        const results = res.map((item) => {
          item.value = item.PRODUCT_NAME;
          return item;
        });
        callback(results);
      });
    },
    exportPrice() {
      this.exportDialog = true;
    },
    closePrice() {
      this.exportDialog = false;
    },
    submitAddSKU() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10020',
            OTYPE: 14,
            SCHEME_ID: this.$route.params.id,
            FILE_NAME: this.file_name,
          };
          if (!this.file_name) {
            this.$message.show({ text: '请上传文件', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
            this.exportDialog = false;
            this.getProduct();
          }).catch((error) => {
            document.body.style.cursor = 'default';
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
          });
        } finally {}
      }
    },
    downLoadSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/exportSpecialPoint.xlsx';
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(response, file, fileList) {
      this.file_name = '';
    },
    // 搜索接口调用
    $_getSearchRushOrderList(NAME) {
      return new Promise((resolve, reject) => {
        const param = {
          PRODUCT_NAME: NAME,
          SERVICE_ID: '10202',
          OTYPE: 92,
        };
        http.post(param).then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    // 进行搜索
    handleSelect(item) {
      this.addForm.PRODUCT_CODE = item.PRODUCT_CODE;
    },
    //   拉取产品信息
    queryProductCatalog() {
      const param = {
        SERVICE_ID: '10202',
        OTYPE: 16,
        TC_ID: Number(sessionStorage.getItem('companyId')),
      };
      http.post(param).then((result) => {
        this.product = result[0].OP_ROLE;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 产品列表
    getProduct() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 16,
        SCHEME_ID: this.SCHEME_ID,
        GYS_ID: this.GYS_ID,
      };
      http.post(params).then((res) => {
        if (res.length === 0 || res[0].PRODUCT_LIST.length === 0) {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = res[0].PRODUCT_LIST;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增特殊产品加点
    submitAddPrice() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 15,
        SCHEME_ID: this.SCHEME_ID,
        POINT: this.addForm.POINT,
        GYS_ID: this.GYS_ID,
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
      };
      if (!this.addForm.productName || !this.addForm.POINT) {
        this.$message.show({ text: '请输入产品名称和加点级别', type: 'warning' });
        return false;
      }
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.addForm.POINT)) {
        this.$message.show({ text: '请输入正数加点级别', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.getProduct();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改大类名称
    editName(row) {
      this.editDialog = true;
      this.editForm = row;
    },
    // 提交修改模态框
    submitEditPrice() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 17,
        SCHEME_PRODUCT_ID: this.editForm.SCHEME_PRODUCT_ID,
        POINT: this.editForm.POINT,
        PRODUCT_CODE: this.editForm.PRODUCT_CODE,
      };
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.editForm.POINT)) {
        this.$message.show({ text: '请输入正数加点级别', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editDialog = false;
        this.getProduct();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteName(row) {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 18,
        SCHEME_PRODUCT_IDS: [row.SCHEME_PRODUCT_ID],
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.getProduct();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addPrice() {
      this.addDialog = true;
    },
    queryProject(event) {
      sessionStorage.setItem('CODE', event);
    },
    deleteAll() {
      this.$confirm('您确定要删除所有加点？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10023',
          OTYPE: 18,
          SCHEME_PRODUCT_IDS: this.tableData.map((item) => item.SCHEME_PRODUCT_ID),
        };
        http.post(params).then((res) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.getProduct();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      });
    },
  },

};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}

.inline-input {
  width: 206.4px;
}</style>



// WEBPACK FOOTER //
// src/components/priceManagement/specialPrice.vue